import React from 'react';

const EMPTY = {};
export const PREMATCH = { prematch: true };
export const PREMATCH_FAV = { prematch: true, favoritesOnly: true };
export const LIVE = { live: true };

export default React.createContext(EMPTY);
